import certificate_01 from "../../../assets/images/certificate_01.svg";
import user22 from "../../../assets/images/user22.svg";

import partnerhead_pc from "../../../assets/images/partnerhead_pc.webp";
import partnerhead_mo from "../../../assets/images/partnerhead_mo.webp";

export default function PartnerHead() {
  return (
    <div className="w-full container mx-auto p-3 flex flex-col md:flex-col lg:flex-row mt-4 ">
      <div className="w-full flex flex-col gap-4 ">
        <div className="flex items-center gap-2">
          <p className="text-[1.125rem] font-semibold text-[#033F6A]">
            Về chúng tôi
          </p>
          <div className="border border-[#27C6FF] w-[7.125rem] h-10 rounded-[40px] bg-[#27C6FF] flex items-center justify-center">
            <p className="text-[1.125rem] font-semibold text-white">
              BlueSkyIT
            </p>
          </div>
        </div>
        <div>
          <p className="font-semibold text-[1.5rem] md:text-[1.75rem] lg:text-[1.75rem] text-[#27C6FF] lg:w-[30rem]">
            Đôi điều về Bầu Trời Xanh (BlueSkyIT)
          </p>
        </div>
        <div className="lg:w-[31.875rem]">
          <p className="text-[1rem] font-normal text-[#333] lg:leading-8">
            Bầu Trời Xanh{" "}
            <spam className=" font-semibold text-black">(BlueSkyIT) </spam>là
            đơn vị tiên phong trong việc phát triển các giải pháp công nghệ tiên
            tiến phục vụ giáo dục, sức khoẻ & đào tạo. Với đội ngũ chuyên gia
            dày dặn kinh nghiệm không ngừng đổi mới để mang lại sản phẩm tốt
            nhất cho cộng đồng. Chúng tôi luôn hướng tới việc tạo ra giá trị bền
            vững và hỗ trợ khách hàng phát triển trong thời đại số hóa.
          </p>
        </div>
        <div className="flex flex-row gap-4 md:flex-row lg:flex-row md:gap-3 lg:gap-3">
          <div className="flex flex-row items-center gap-3 w-full">
            <div className="w-10 h-10 bg-[#DBF4FF] flex items-center justify-center rounded-full relative top-[-23px]">
              <img src={certificate_01} alt="cer" />
            </div>
            <div className="flex flex-col gap-2">
              <p className="text-[#333] font-semibold w-[115px] text-[1rem]">
                Chứng nhận công ty
              </p>
              <p className="text-[1rem] font-normal text-[#606060] w-[115px] lg:w-[11.875rem]">
                Dịch vụ kỹ năng cung cấp tốt nhất
              </p>
            </div>
          </div>
          <div className="flex flex-row items-center gap-3">
            <div className="w-10 h-10 bg-[#DBF4FF] flex items-center justify-center rounded-full relative top-[-23px]">
              <img src={user22} alt="user" />
            </div>
            <div className="flex flex-col gap-2">
              <p className="text-[#333] font-semibold text-[1rem] w-[115px]">
                Đội ngũ chuyên gia
              </p>
              <p className="text-[1rem] font-normal text-[#606060] lg:w-[11.875rem] w-[115px]">
                100% có trình độ, kỹ năng cao
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-7">
        <img
          src={partnerhead_mo}
          alt="infor_mobi"
          className="block md:hidden lg:hidden w-full object-cover"
        />
        <img
          src={partnerhead_pc}
          alt="infor_pc"
          className="hidden md:block lg:max-w-full lg:h-auto lg:block object-contain"
        />
      </div>
    </div>
  );
}
